import React, { useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { SwitchSectionDiv } from "./styled";
import {
   IDonorContactPreference,
   IDonorDataService,
} from "../../../../../services/bexWISE/donorDataService/IDonorDataService";
import { getDonorDataServiceInstance } from "../../../../../services/bexWISE/donorDataService/getDonorDataServiceInstance";
import { AuthContext } from "../../../../contexts/auth/authContext";
// == SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages ==
import { RiInformationFill } from "react-icons/ri";
import { Tooltip } from "primereact/tooltip";
// SCREDP-112 - Prevent multiple submissions while save request operations are executing
import { CommonContext } from "app/contexts/common/commonContext";

function SwitchSectionComponent({
   sectionsContent,
   preferencesDisplayData,
   setPreferencesDisplayData,
   isMobile,
}) {
   const { userDonorId } = useContext(AuthContext);
   // SCREDP-112 - Prevent multiple submissions while save request operations are executing
   const { startLoading, stopLoading } = React.useContext(CommonContext);

   const isPreferenceSelected = (
      eachSwitch: IDonorContactPreference,
   ): boolean => {
      return Boolean(
         preferencesDisplayData.find(
            eachVal =>
               eachVal.contactPreferenceCode ===
               eachSwitch.contactPreferenceCode,
         ),
      );
   };

   const setPreferencesAPI = async (
      preferences: IDonorContactPreference[],
   ): Promise<void> => {
      
      if (userDonorId) {
         try {
            const donorDriveDataService: IDonorDataService =
               getDonorDataServiceInstance();
            await donorDriveDataService.setDonorContactPreferences(
               userDonorId,
               preferences,
               // SCREDP-112 - Prevent multiple submissions while save request operations are executing
               startLoading,
               stopLoading
            );
            setPreferencesDisplayData(preferences);
         } catch (err) {
            throw err;
         }
      }
   };

   const setPreferencesFunction = (
      isChecked: boolean,
      eachSwitch: IDonorContactPreference,
   ) => {
      if (isChecked) {
         const preferencesSelected: IDonorContactPreference[] = [
            ...preferencesDisplayData,
            {
               contactPreferenceCode: eachSwitch.contactPreferenceCode,
               contactPreferenceDescription:
                  eachSwitch.contactPreferenceDescription,
            },
         ];
         setPreferencesAPI(preferencesSelected);
      } else {
         const preferencesSelected: IDonorContactPreference[] =
            preferencesDisplayData.filter(
               (eachVal: { contactPreferenceCode: string }) =>
                  eachVal.contactPreferenceCode !==
                  eachSwitch.contactPreferenceCode,
            );
         setPreferencesAPI(preferencesSelected);
      }
   };

   return (
      <SwitchSectionDiv className={isMobile ? "mobile-css" : "desktop-css"}>
         <Col className="image-section">
            <div>
               <Image
                  src={sectionsContent.image}
                  fluid
                  alt={`${sectionsContent.label}-img`}
                  className={`${sectionsContent.id}-image-css`}
               />
            </div>
            {/* SCREDP-95 Allow Admin Customization of Text Displayed on Various Donor Portal Pages */}
            <Tooltip target={"#"+sectionsContent.id+"RiInformationFill"} />
            <div className="label-css">
               {sectionsContent.label}<RiInformationFill 
                  id={sectionsContent.id+"RiInformationFill"}
                  data-pr-tooltip={sectionsContent.message}
                  data-pr-position="bottom"
                  fill="black" 
                  size={20} 
               />
            </div>
         </Col>
         {!isMobile && <Col className="vertical-line-css"></Col>}
         <Row>
            {sectionsContent.switches.map(eachSwitch => (
               <Col xs={6} sm={4} key={eachSwitch.contactPreferenceCode}>
                  <Form.Check
                     type="switch"
                     id={eachSwitch.contactPreferenceCode}
                     label={eachSwitch.name}
                     checked={isPreferenceSelected(eachSwitch)}
                     onChange={e =>
                        setPreferencesFunction(e.target.checked, eachSwitch)
                     }
                     className="each-switch-div"
                  />
               </Col>
            ))}
         </Row>
      </SwitchSectionDiv>
   );
}

export default SwitchSectionComponent;
